export default __webpack_public_path__ + "static/mateuszb-5c24c7248335caa5e38e8cc7baf27357.jpg";